import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home"
    // component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/motion",
    name: "motion",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/motion/Motion.vue")
  },
  {
    path: "/pushes",
    name: "pushes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/pushes/Pushes.vue")
  },
  {
    path: "/policy",
    name: "policy",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/policy/policy.vue")
  },
  {
    path: "/facebook",
    name: "facebook",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "about" */ "../views/marketing/facebook/Facebook.vue"
        ),
      accounts: () =>
        import(
          /* webpackChunkName: "about" */ "../views/marketing/facebook/Accounts.vue"
        )
    },
    children: [
      {
        name: "facebook-account",
        path: ":accountId/account",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "about" */ "../views/marketing/facebook/Account.vue"
            ),
          subnav: () =>
            import(
              /* webpackChunkName: "about" */ "../views/marketing/facebook/Subnav.vue"
            )
        },
        // component:,
        children: [
          {
            name: "facebook-requests",
            path: "requests",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "../views/marketing/facebook/Requests.vue"
              )
          },
          {
            name: "facebook-audiences",
            path: "audiences",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "../views/marketing/facebook/Audiences.vue"
              )
          },
          {
            name: "facebook-campaings",
            path: "campaigns",

            components: {
              campaigns: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/Campaigns.vue"
                ),
              selectedCampaigns: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/SelectedCampaigns.vue"
                ),
              advideos: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/Advideos.vue"
                ),
              selectedAdvideos: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/SelectedAdvideos.vue"
                ),
              adimages: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/Adimages.vue"
                ),
              selectedAdimages: () =>
                import(
                  /* webpackChunkName: "about" */ "../views/marketing/facebook/SelectedImages.vue"
                )
            }
          }
        ]
      }
    ]
  },
  {
    path: "/feedbacks",
    name: "feedbacks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/feedbacks/feedbacks.vue")
  },
  {
    path: "/feedbacks-dev",
    name: "feedbacks-dev",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/feedbacks/feedbacks-dev.vue"
      )
  },
  {
    path: "/sudoku",
    name: "sudoku",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/games/sudoku/Sudoku.vue"
      ),
    children: [
      {
        path: "daily",
        name: "sudokuDaily",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/games/sudoku/DailyRecords.vue"
          )
      },
      {
        path: "players",
        name: "sudokuPlayers",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/games/sudoku/Players.vue"
          )
      }
    ]
  },
  {
    path: "/google",
    name: "google",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/marketing/Google.vue")
  },
  {
    path: "/tiktok",
    name: "tiktok",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/marketing/Tiktok.vue")
  },
  {
    path: "/snapchat",
    name: "snapchat",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/marketing/Snapchat.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  //@ts-ignore
  routes
});

export default router;
